<template>
  <div
    class="matching__entrance" 
    :class="{'is-list': showList.length}"
    @click="toMatchingDetail"
  >
    <span v-if="entranceData.finishStatus === 2" class="matching__unfinish">未完成</span>
    <template v-if="showList.length">
      <img
        v-for="(item, index) in showList" 
        :key="index" 
        :style="{'z-index': showList.length - index}" 
        :src="item"
        alt=""
      >
      <img v-if="entranceData.matchList.length > 7" src="@/assets/matching/img-more.png" alt="">
    </template>
  </div>
</template>

<script>
import APIS from '@/apis'
export default {
  props: {
    entranceData: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {}
  },

  computed: {
    showList() {
      if (this.entranceData.matchList && this.entranceData.matchList.length) {
        return this.entranceData.matchList.slice(0, 7)
      }
      return []
    }
  },

  methods: {
    toMatchingDetail() {
      // 未购买且未完成答题
      if (!this.entranceData.buyStatus && this.entranceData.finishStatus === 2) {
        this.createOrder()
        return
      }
      this.$router.push({
        name: 'matchingDetail',
        query: {
          channelId: this.channelId
        }
      })
    },

    // 去测试
    createOrder() {
      this.$http.get(APIS.matchTestToReport, {
        params: {
          channelId: this.channelId
        }
      }).then(res => {
        const {data, code} = res.data
        if (code === '302') {
          location.href = data
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/scss/function';

.matching__entrance {
  position: relative;
  margin: topx(30rem) topx(0) topx(10rem) topx(40rem);
  height: topx(180rem);
  width: topx(670rem);
  background: url(~@/assets/matching/img-entrance.png) no-repeat;
  background-size: contain;
  border-radius: topx(10rem);
  box-shadow: 0 topx(2rem) topx(6rem) rgba(0, 0, 0, .4);
  text-align: center;
  font-size: 0;
  overflow: hidden;

  &.is-list {
    background: url(~@/assets/matching/img-entrance-avatar.png) no-repeat;
    background-size: contain;
  }

  .matching__unfinish {
    position: absolute;
    left: 0;
    top: 0;
    width: topx(120rem);
    height: topx(46rem);
    background: #CDD6FF;
    color: #9098A5;
    font-size: topx(26rem);
    line-height: topx(46rem);
    text-align: center;
    font-weight: 500;
    border-radius: 0 0 topx(20rem) 0;
  }

  img {
    position: relative;
    margin-top: topx(124rem);
    margin-left: topx(-10rem);
    width: topx(36rem);
    height: topx(36rem);
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/matching/components/matchingEntrance.vue